import { useMutation } from '@tanstack/react-query'
import { useAccessToken } from '@/features/auth/state/auth'

import api from '@/lib/api'
export function useCreatedAnexoApuracao() {
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({
      id_client,
      id_calculo,
      id_product,
      id_apuracao_competencia,
      nome,
      anexo,
      id_apuracao
    }: {
      id_client: string
      id_calculo: string
      id_product: string
      id_apuracao_competencia: string
      id_apuracao: string
      nome: string
      anexo: File
    }) => {
      if (!token) throw new Error('Token está ausente')
      if (!anexo) throw new Error('Arquivo de Anexo é obrigatório')

      const formData = new FormData()
      formData.append('id_client', id_client)
      formData.append('id_calculo', id_calculo)
      formData.append('id_apuracao', id_apuracao)
      formData.append('nome', nome)
      formData.append('anexo', anexo)
      formData.append('id_product', id_product)
      formData.append('id_apuracao_competencia', id_apuracao_competencia)
      console.log(id_client, id_calculo, id_apuracao, nome)
      console.log('anexo', anexo)
      const response = await api.post(`/anexos`, formData)

      if (response.data) {
        return response.data
      } else {
        throw new Error('Erro ao adicionar assinatura')
      }
    }
  })
}
